<div class="d-flex align-items-center mb-3">
  <h3 class="mb-0 text-black">New Product</h3>
  <div class="d-flex align-items-center gap-2 ms-auto">
    <button class="btn btn-primary btn-h42 w-100 justify-content-center" (click)="submitProduct(true)">
      <i class="bi bi-box-seam me-1"></i> Save Product
    </button>
    @if (!selectedProductId()) {
      <button
        class="btn btn-outline-secondary btn-h42 w-100 justify-content-center text-nowrap"
        (click)="submitProduct()"
      >
        <i class="bi bi-floppy me-1"></i>Save & Add Another
      </button>
    }
  </div>
</div>
<form [formGroup]="productForm">
  <div class="row gy-3">
    <div class="col">
      <div class="p-3 border rounded-4 mb-4">
        <h3 class="mb-3 text-black">Product Details</h3>

        <div class="row gy-3">
          <div class="col-xxl-3 col-xl-4 col-lg-6">
            <input-field
              [label]="'Product Code'"
              [required]="true"
              [requiredLabel]="true"
              [errormessage]="'Product Code is required'"
              [type]="'text'"
              [placeholder]="'Enter Product Code'"
              formControlName="code"
            ></input-field>
          </div>
          <!-- <div class="col-xxl-3 col-xl-4 col-lg-6">
            <input-field
              [label]="'Manufacturer Code'"
              [type]="'text'"
              [placeholder]="'Enter Manufacturer Code'"
              formControlName="manufacturerCode"
            ></input-field>
          </div> -->
          <div class="col-xxl-3 col-xl-4 col-lg-6">
            <generic-dropdown
              [items]="UOFMList()"
              [label]="'Unit of Measurement'"
              [placeholder]="'Select Unit of Measurement'"
              [required]="false"
              [allowSearch]="true"
              [clearable]="false"
              formControlName="uofmId"
            ></generic-dropdown>
          </div>
          <div class="col-xxl-3 col-xl-4 col-lg-6">
            <generic-dropdown
              [items]="tasks()"
              [label]="'Cutoff Task'"
              [placeholder]="'Select Cutoff Task'"
              [required]="false"
              [allowSearch]="true"
              [clearable]="false"
              formControlName="cutoffTaskId"
            ></generic-dropdown>
          </div>
          <div class="col-xxl-3 col-xl-4 col-lg-6">
            <generic-dropdown
              [items]="locations()"
              [label]="'Location'"
              [placeholder]="'Select Location'"
              [required]="false"
              [allowSearch]="true"
              [clearable]="false"
              [multiselect]="true"
              formControlName="locationIds"
            ></generic-dropdown>
          </div>
        </div>
      </div>
      <div class="p-3 border rounded-4 mb-4">
        <h3 class="mb-3 text-black">Descriptions</h3>
        <div class="row gy-3">
          <div class="col-xxl-6">
            <label class="form-label">Product Description</label>
            <textarea
              class="form-control"
              rows="4"
              [placeholder]="'Type here...'"
              formControlName="description"
            ></textarea>
          </div>
          <div class="col-xxl-6">
            <label class="form-label">Sales Description</label>
            <textarea
              class="form-control"
              rows="4"
              [placeholder]="'Type here...'"
              formControlName="salesDescription"
            ></textarea>
          </div>
        </div>
      </div>
      <div class="p-3 border rounded-4">
        <h3 class="mb-3 text-black">Assignment</h3>
        <div class="row gy-3">
          <div class="col-xxl-3 col-xl-4 col-lg-6">
            <generic-dropdown
              [items]="productList$ | async"
              [label]="'Product List'"
              [placeholder]="'Select Product List'"
              [required]="true"
              [allowSearch]="true"
              [clearable]="false"
              [errormessage]="'Product List is required'"
              formControlName="productListId"
            >
            </generic-dropdown>
          </div>
          <div class="col-xxl-3 col-xl-4 col-lg-6">
            <generic-dropdown
              [items]="category$ | async"
              [label]="'Category'"
              [placeholder]="'Select Category'"
              [required]="true"
              [allowSearch]="true"
              [clearable]="false"
              [errormessage]="'Category is required'"
              formControlName="categoryId"
            >
            </generic-dropdown>
          </div>
          <div class="col-xxl-3 col-xl-4 col-lg-6">
            <generic-dropdown
              [items]="subcategory$ | async"
              [label]="'Subcategory'"
              [placeholder]="'Select Subcategory'"
              [required]="true"
              [allowSearch]="true"
              [clearable]="false"
              [errormessage]="'Subcategory is required'"
              formControlName="subcategoryId"
            >
            </generic-dropdown>
          </div>
          <div class="col-xxl-3 col-xl-4 col-lg-6">
            <generic-dropdown
              [items]="taxCategory()"
              [label]="'Tax Category'"
              [placeholder]="'Select Tax Category'"
              [allowSearch]="true"
              [clearable]="false"
              [required]="true"
              [errormessage]="'Tax Category is required'"
              formControlName="taxCategoryId"
            >
            </generic-dropdown>
          </div>

          <div class="col-auto">
            <generic-dropdown
              [items]="productClass()"
              [label]="'Product Class'"
              [placeholder]="'Select Product Class'"
              [required]="true"
              [allowSearch]="true"
              [clearable]="false"
              [errormessage]="'Product Class is required'"
              formControlName="productClassId"
            >
            </generic-dropdown>
          </div>
        </div>
      </div>
    </div>
    <div class="right-deal-box position-sticky top-0">
      <div class="border rounded rounded-3 overflow-hidden p-3 mb-3">
        <h3 class="mb-3 text-black">Product images</h3>
        @if (productImageItems().length > 0) {
          <div class="mb-3 mt-2">
            @for (item of productImageItems(); track idx; let idx = $index) {
              <div class="d-flex align-items-center border rounded-3 p-2 mb-2 gap-2 bg-white">
                @if (item.url) {
                  <lib-image-preview
                    class="w-auto h-auto"
                    [images]="productPreviewImages()"
                    [title]="productForm.get('code')?.value ?? ''"
                  >
                    <img
                      [src]="item.url"
                      alt=""
                      class="rounded-2 object-fit-cover cursor-pointer"
                      style="width: 56px; height: 56px"
                    />
                  </lib-image-preview>
                }
                <div class="flex-grow-1 min-w-0">
                  <div>
                    <span class="text-truncate small fw-500" [title]="item.name">
                      {{ item.name.length > 20 ? (item.name | slice: 0 : 20) + '...' : item.name }}
                    </span>
                    @if (idx === 0) {
                      <span class="badge bg-primary-subtle text-white ms-1">Primary</span>
                    }
                  </div>
                  <div class="text-secondary small">
                    @if (item.size) {
                      {{ item.size / 1024 | number: '1.3-3' }} KB
                    }
                  </div>
                </div>
                <div class="d-flex align-items-center gap-2">
                  <button
                    type="button"
                    class="btn btn-link text-danger p-0"
                    (click)="removeProductImage(idx)"
                    aria-label="Remove"
                  >
                    <i class="bi bi-x-lg"></i>
                  </button>
                  <button type="button" class="btn btn-link p-0" (click)="reuploadAt = idx; reuploadInp.click()">
                    <i class="bi bi-arrow-clockwise"></i>
                  </button>
                </div>
              </div>
            }
          </div>
        }
        <input #reuploadInp class="d-none" type="file" accept="image/*" (change)="onReuploadFile($event)" />
        <file-drop
          class="mb-3"
          [fileAcceptedFormat]="'.png,.jpg,.jpeg'"
          [titleMsg]="'Upload Product Images'"
          [buttonText]="'Drag and Drop or'"
          (onFileDrop)="onFileDrop($event)"
        ></file-drop>
      </div>
      <div class="border rounded rounded-3 overflow-hidden">
        <div class="p-3 bg-light">
          <div class="d-flex align-items-center">
            <h3 class="mb-0"><i class="bi bi-gear me-2"></i>Settings</h3>
          </div>
        </div>
        <div class="p-3">
          @if (selectedProductId()) {
            <div class="d-flex align-items-center justify-content-between gap-3 mb-3">
              <h4>Active</h4>
              <p-toggleswitch formControlName="isActive" (onChange)="toggleProduct()" />
            </div>
          }
          <div class="d-flex align-items-center justify-content-between gap-3 mb-3">
            <h4>Global</h4>
            <p-toggleswitch formControlName="isGlobal" (onChange)="submitProduct()" />
          </div>
          <div class="d-flex align-items-center justify-content-between gap-3">
            <h4>Sellable</h4>
            <p-toggleswitch formControlName="sellable" (onChange)="submitProduct()" />
          </div>
          <hr />
          <div class="d-flex align-items-center justify-content-between gap-3 mb-3">
            <h4>
              Sales Office
              @if (!productForm.get('designCenter')?.value) {
                <span class="text-danger"> *</span>
              }
            </h4>
            <p-toggleswitch formControlName="salesOffice" />
          </div>
          <div class="d-flex align-items-center justify-content-between gap-3">
            <h4>
              Design Center
              @if (!productForm.get('salesOffice')?.value) {
                <span class="text-danger"> *</span>
              }
            </h4>
            <p-toggleswitch formControlName="designCenter" />
          </div>
          @if (
            (productForm.get('salesOffice')?.invalid || productForm.get('designCenter')?.invalid) &&
            (productForm.get('salesOffice')?.touched || productForm.get('designCenter')?.touched)
          ) {
            <div class="text-danger fs-14 mt-2">Please enable Sales Office or Design Center.</div>
          }
          <hr />
          <div class="d-flex align-items-center justify-content-between gap-3 mb-3">
            <h4>Selection Required</h4>
            <p-toggleswitch formControlName="selectionRequired" (onChange)="submitProduct()" />
          </div>

          <!-- <div class="d-flex align-items-center justify-content-between gap-3">
                <h4>Discontinued</h4>
                <p-toggleswitch formControlName="discontinued" />
              </div> -->
          <hr />
          <div class="d-flex align-items-center justify-content-between gap-3 mb-3">
            <h4>Load By Default</h4>
            <p-toggleswitch formControlName="loadByDefault" (onChange)="submitProduct()" />
          </div>
          <div class="d-flex align-items-center justify-content-between gap-3">
            <h4>Applies To All Locations</h4>
            <p-toggleswitch formControlName="appliesToAllLocations" (onChange)="submitProduct()" />
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
